import { render, staticRenderFns } from "./buyFrame.vue?vue&type=template&id=b74eccde"
import script from "./buyFrame.vue?vue&type=script&lang=js"
export * from "./buyFrame.vue?vue&type=script&lang=js"
import style0 from "./buyFrame.vue?vue&type=style&index=0&id=b74eccde&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports